import { useState } from "react";
import ReactApexChart from "react-apexcharts";

const Chart = () => {
  const categories = [
    ["Jan", "Feb", "Mar", "Apr"],
    ["May", "Jun", "Jul", "Aug"],
    ["Sep", "Oct", "Nov", "Dec"],
  ];
  const data = [
    [38000, 33000, 25000, 20000],
    [76000, 19000, 49000, 30000],
    [43000, 138000, 7000, 10000],
  ];

  const [category, setCategory] = useState(categories[0]);
  const [selectedMonth, setSelectedMonth] = useState("Jan");
  const [datum, setDatum] = useState(data[0]);

  const handleMonthChange = (event) => {
    setCategory(categories[parseInt(event.target.value)]);
    setDatum(data[parseInt(event.target.value)]);
    setSelectedMonth(event.target.value);
  };
  const chartOptions = {
    series: [
      {
        name: "Total Donated Funds",
        data: datum,
      },
    ],
    options: {
      chart: {
        id: "column-chart",
      },
      colors: ["#213874", "#F0CA18"],
      xaxis: {
        categories: category,
      },
      dataLabels: {
        enabled: false,
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return "N" + val + " thousands";
          },
        },
      },
    },
  };

  return (
    <div className=" h-full bg-white rounded-lg p-3">
      <p className="flex justify-start font-semibold text-[16px]">Statistics</p>
      <div className="flex items-center">
        <select
          id="month-select"
          value={selectedMonth}
          onChange={handleMonthChange}
          className="border-none outline-none bg-white my-2"
        >
          <option value={0}>Jan - Apr</option>
          <option value={1}>May - Aug</option>
          <option value={2}>Sep - Dec</option>
        </select>
      </div>
      <ReactApexChart
        options={chartOptions.options}
        series={chartOptions.series}
        type="bar"
        height={350}
      />
    </div>
  );
};

export default Chart;
